import createId from "@/lib/create-id";

import { ItemType } from "@/types/enums/item-type";
import { PackageShopCartLine, ShopItem } from "@/types/shop";

export const packageLineFromItem = (item: ShopItem): PackageShopCartLine => ({
  kind: "package",
  lineId: createId("cl"),
  itemType: ItemType.PACKAGE,
  itemId: item.id,
  unitPriceCents: item.price,
  expectedUnitPriceCents: item.price,
  quantity: 1,
  snapshot: {
    name: item.name,
    description: item.description,
    imageUrl: item.imageUrl,
    category: item.category,
    packageSavings: item.packageSavings,
    packageIncludedItems: item.packageIncludedItems,
    requiresPickupLocation: item.requiresPickupLocation,
  },
});
